<script setup lang="ts">
import {
  ToastTitle as ToastTitleComponent,
  type ToastTitleProps,
} from "reka-ui";
import { type HTMLAttributes, computed } from "vue";
import { cn } from "@/lib/utils";

interface Props extends ToastTitleProps {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();

const delegatedProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <ToastTitleComponent
    v-bind="delegatedProps"
    :class="cn('text-sm font-semibold [&+div]:text-xs', props.class)"
  >
    <slot />
  </ToastTitleComponent>
</template>
